import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { MediaAPI } from '@shared-features/services';
import { LoadingService } from '@shared/services/loading.service';
import { SectionState } from '@shared-features/enums/layout.enum';
import { BaseComponent } from '@shared-features/components/base-component/base.component';

@Component({
  selector: 'app-uploaded-file',
  templateUrl: './uploaded-file.component.html',
  styleUrls: ['./uploaded-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadedFileComponent extends BaseComponent {
  @Input() title!: string;
  @Input() mediaId!: number;
  @Output() downloadClicked = new EventEmitter();

  constructor(private mediaApiService: MediaAPI) {
    super();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onDownloadClicked(): void {
    if (this.mediaId) {
      this.load(this.mediaApiService.getMedia(this.mediaId), {
        isLoadingTransparent: true,
      }).subscribe((media) => {
        window.open(media.url, '_blank');
      });
    } else {
      this.downloadClicked.emit({});
    }
  }
}
